export const focus = {
  inserted(el){
    el?.focus?.()
  }
} 